import { createRoute, lazyRouteComponent, stripSearchParams } from '@tanstack/react-router'

import { requireBackoffice } from '../auth/guard.ts'
import { numericIdParam, parseOneOf } from './params.ts'
import { rootRoute } from './root.tsx'

// The change reports queue, a tab of Partite (spec #404), and one report with the match form.

export const REPORT_SHOWS = ['open', 'all'] as const

export type ReportShow = (typeof REPORT_SHOWS)[number]

export interface MatchReportsSearch {
  readonly show: ReportShow
}

export const DEFAULT_MATCH_REPORTS_SEARCH: MatchReportsSearch = { show: 'open' }

export const matchReportsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/matches/reports',
  validateSearch: (search: Record<string, unknown>): MatchReportsSearch => ({
    show: parseOneOf(REPORT_SHOWS, search.show) ?? 'open',
  }),
  search: { middlewares: [stripSearchParams(DEFAULT_MATCH_REPORTS_SEARCH)] },
  beforeLoad: requireBackoffice,
  component: lazyRouteComponent(() => import('../pages/match-reports.tsx')),
})

/** A function, as `matchListLink`: `route.to` is only set once the route tree is built. */
export function matchReportListLink() {
  return { to: matchReportsRoute.to, search: DEFAULT_MATCH_REPORTS_SEARCH } as const
}

export const matchReportDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/matches/reports/$id',
  params: numericIdParam,
  beforeLoad: requireBackoffice,
  component: lazyRouteComponent(() => import('../pages/match-report-detail.tsx')),
})

export function matchReportLink(reportId: number) {
  return { to: matchReportDetailRoute.to, params: { id: reportId } } as const
}
